export default {
    PRODUCT: {code: 'PRODUCT', title: 'Producto'},
    TAX: {code: 'TAX', title: 'Impuesto'},
    SERVICE: {code: 'SERVICE', title: 'Servicio'}
};